// extracted by mini-css-extract-plugin
export default {"container":"modal_scrollable_footer-module__container--hhARG"};